import * as React from 'react'

const Confirm = () => (
  <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 6L5 10L14 1" stroke="#4451DE" strokeWidth="2" />
  </svg>
)

export default Confirm
